import * as React from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { withRouter, RouteComponentProps } from 'react-router';
import { compose } from 'redux';
import { Drawer } from 'components/';
import * as Queries from 'api/graphql/queries';
import { OrderDirection, donations, donations_donations_paginatorInfo, AdminDonationOrderField, AdminDonationItem } from '@api/graphql/types';
import GraphQLClient from '@api/graphql/GraphQLClient';
import ControlledTable from '@components/ControlledTable';
import { RowInfo } from 'react-table';
import { Column } from 'react-virtualized';
import { Paths } from '..';
import { ApolloQueryResult } from 'apollo-client';
import Notification from 'components/Notification';
import { DispatchProp, connect } from 'react-redux';
import { updateListOptions } from '@actions/listActions';
import { ApplicationState } from 'reducers/';
import { ListOptionType } from '@reducers/listReducer';
import { OpenInNewCell } from '@components/Table/Cell';

interface StateType {
    isLoading: boolean;
    data: AdminDonationItem[];
    paginatorInfo: donations_donations_paginatorInfo | {};
}
interface ReduxProps {
    listOptions: ListOptionType;
}

export const DonationListDefaultOptions = {
    sortBy: {
        field: 'created_at',
        direction: OrderDirection.DESC,
    },
    count: 10,
    page: 0,
};

const listName = 'donationList';

type Props = ReduxProps & DispatchProp & InjectedIntlProps & RouteComponentProps;

class DonationList extends React.Component<Props, StateType> {
    public state = {
        isLoading: true,
        data: [],
        paginatorInfo: {},
    };

    private OpenCell = OpenInNewCell((rowInfo: any) => {
        return `${Paths.donation}/${rowInfo.original.id}`;
    });

    // TODO: Put first_donation and last_donation into response when backend fix is in
    private tableColumns = [
        {Header: '', sortable: false, Cell: this.OpenCell, width: 30},
        this.getDefaultColumnByName('name', { sortable: true }),
        this.getDefaultColumnByName('active_from', { sortable: true, width: 175 }),
        this.getDefaultColumnByName('active_to', { sortable: true, width: 175 }),
        this.getDefaultColumnByName('cms_url'),
        this.getDefaultColumnByName('donation_total', { sortable: true }),
        // this.getDefaultColumnByName('first_donation', { sortable: true }),
        // this.getDefaultColumnByName('last_donation', { sortable: true }),
    ];

    public componentDidMount() {
        this.fetchData();
    }

    public componentDidUpdate(prevProps: Props) {
        if (prevProps.listOptions !== this.props.listOptions) {
            this.fetchData();
        }
    }

    private getDefaultColumnByName(name: string, options: any = {}) {
        return {
            Header: this.label(`${name}.title`),
            accessor: name,
            sortable: false,
            ...options,
        };
    }

    private label(id: string): string {
        return this.props.intl.formatMessage({ id: `module.donation.${id}` });
    }

    private getSortBy(): {field: string, direction: string} {
        return {
            field: AdminDonationOrderField[this.props.listOptions.sortBy.field.toUpperCase()],
            direction: this.props.listOptions.sortBy.direction,
        };
    }

    private fetchData() {
        this.setState({ isLoading: true }, () => {
            const variables = {
                ...this.props.listOptions,
                page: this.props.listOptions.page + 1,
                sortBy: this.getSortBy(),
            };
            GraphQLClient.query<donations>({
                query: Queries.donations,
                variables,
            }).then((response: ApolloQueryResult<donations>) => {
                const data = response.data.donations ? response.data.donations.data : [];
                const paginatorInfo = response.data.donations ? response.data.donations.paginatorInfo : {};
                this.setState({data, paginatorInfo});
            }).catch(() => {
                Notification.error(this.props.intl.formatMessage({ id: 'notification.failed' }));
            });
            this.setState({ isLoading: false });
        });
    }

    private onOptionsChange = (options: ListOptionType) => {
        this.props.dispatch(updateListOptions(listName, options));
    }

    private onRowClick = (finalState: any, rowInfo?: RowInfo, column?: Column, instance?: any): object | undefined => {
        if (rowInfo) {
            return {
                onClick: () => {
                    this.props.history.push(`${Paths.donation}/${rowInfo.original.id}`);
                },
                style: {
                    cursor: 'pointer',
                },
            };
        }
        return {};
    }


    public render() {
        const addButton = <button className="btn btn-primary" onClick={(e: React.SyntheticEvent) => this.props.history.push(Paths.donationCreate)}>{this.label("newDonation")}</button>;

        return (
            <Drawer headerButton={addButton}>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ibox float-e-margins">
                            <div className="ibox-content">
                                <ControlledTable
                                    listName={listName}
                                    defaultOptions={DonationListDefaultOptions}
                                    columns={this.tableColumns}
                                    options={this.props.listOptions}
                                    data={this.state.data}
                                    paginatorInfo={this.state.paginatorInfo}
                                    onOptionsChange={this.onOptionsChange}
                                    onRowClick={this.onRowClick}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Drawer>
        );
    }
}

const mapStateToProps = ({ lists }: ApplicationState): ReduxProps => {
    return { listOptions: (lists ? (lists[listName] || DonationListDefaultOptions) : DonationListDefaultOptions) };
};

export default compose(
    withRouter,
    injectIntl,
    connect(mapStateToProps),
)(DonationList);



// WEBPACK FOOTER //
// ./src/modules/Donation/pages/DonationList.tsx